import React, {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Input, Popconfirm, message, Tooltip, Form, Select, Modal } from "antd";
import styles from "../index.module.less";
import { CopyTwoTone } from "@ant-design/icons";
import _lodash, { get } from "lodash";
import { ajaxApiGet } from "../../../../server/index";
import common from "@/public/common";
import { getParmUrl } from "@/public/utils";
import OxygenPermeabilityModal from "./oxygenPermeabilityModal";
import OxygenPermeabilityCoefficient from "./oxygenPermeabilityCoefficientModal";
const ExtendForm = forwardRef(({ addData, changeData, getCurrent }, ref) => {
  const [info, setInfo] = useState([]);
  const [initData, setInitData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [modalCount, setModalCount] = useState([0]);

  const [oxygenPermeabilityModalVisabel, setOxygenPermeabilityModalVisabel] =
    useState(false);
  const [oxygenCountHPa, setOxygenCountHPa] = useState(null);
  const [oxygenCountMmhg, setOxygenCountMmhg] = useState(null);

  const [
    oxygenPermeabilityCoefficientModalVisabel,
    setOxygenPermeabilityCoefficientModalVisabel,
  ] = useState(false);
  const [oxygenPermeabilityModalID, setOxygenPermeabilityModalID] =
    useState(null); // 这个id用于修改透氧系数和透氧量
  const [oxygenMmhg, setOxygenMmhg] = useState(null);
  const [contactOxygen, setContactOxygen] = useState(null);

  //存入缓存并保存state
  function saveSession() {
    let data = Object.keys(form.getFieldsValue()).map((item) => {
      return { ...form.getFieldsValue()[item], color: item };
    });
    const addDataClone = _lodash.cloneDeep(addData);
    addDataClone.extend_color_properties = data;
    addDataClone.color_propertys = data;
    changeData(addDataClone);
    sessionStorage.setItem("addData", JSON.stringify(addDataClone));
  }
  //复制花色
  function copyInfo() {
    if (info.length > 1) {
      info.map((item) => {
        form.setFieldValue(item, form.getFieldValue(info[0]));
      });
      message.info("复制成功");
    }
  }
  //复制当前行 english_name：数组名称是什么
  function copyLineInfo(english_name) {
    info.map((pre) => {
      form.setFieldValue(pre, {
        ...form.getFieldValue(pre),
        [english_name]: form.getFieldValue(info[0])[english_name],
      });
    });
    saveSession();
  }
  //初始化获取扩展数据
  function getCurrencyList() {
    const session = JSON.parse(
      sessionStorage.getItem("addData")
    ).extend_color_properties; //缓存
    ajaxApiGet({
      url:
        common.scpUrl +
        `item/category-attrs?category=${getParmUrl("categoryid")}`,
    }).then((res) => {
      if (res.data.code === 200) {
        //过滤更换周期和是否彩色选项
        res.data.data.extra_attrs = res.data.data.extra_attrs.filter(
          (item) =>
            item.english_name !== "ContactsType" &&
            item.english_name !== "ContactDiscardCycle"
        );
        //大写换小写和后端保持一致
        res.data.data.extra_attrs.map((item) => {
          item.english_name = item.english_name.toLowerCase();
        });
        //保存基础数据
        setInitData(res.data.data.extra_attrs);
        //如果有缓存，则使用缓存数据
        if (session) {
          let data = session.map((item) => {
            form.setFieldValue(item.color, item);
            return item.color;
          });
          setInfo(data);
        }
      }
    });
  }
  //批量设置
  function handleOk() {
    modalCount.map((item) => {
      modalForm.getFieldValue(item).color.map((ele) => {
        form.setFieldValue(info[ele], {
          ...form.getFieldValue(info[ele]),
          [modalData.english_name]:
            modalForm.getFieldValue(item)[modalData.english_name],
        });
      });
    });
    modalForm.resetFields();
    message.success("添加成功");
    setModalCount([0]);
    setIsModalOpen(false);
    saveSession();
  }
  //表单提交
  function formSebmit() {
    if (JSON.stringify(form.getFieldsValue()) === "{}") {
      message.warn("请填写花色及扩展属性");
      return false;
    }
    form.submit();
  }
  //下一步
  function onFinish() {
    saveSession();
    getCurrent(1);
  }
  //表单校验
  function onFinishFailed(e) {
    let errTip = e.errorFields[0].errors[0] || "";
    let colorName = e.errorFields[0].name[0];
    message.warn("请输入" + colorName + errTip.slice(3, errTip.length));
  }
  //暴露方法和数据
  useImperativeHandle(
    ref,
    () => {
      return { formSebmit };
    },
    []
  );
  useEffect(() => {
    getCurrencyList();
    //初始化表单写入
  }, []);

  // 修改透氧量
  const oxygenPermeabilityModalOk = (info) => {
    try {
      let mmhg =
        info.mmhg === 0
          ? "0.00Dk/t单位(mmHg)"
          : info.mmhg
          ? Number(info.mmhg || 0).toFixed(2) + "Dk/t单位(mmHg)"
          : null;
      let hpa =
        info.hpa === 0
          ? "0.00Dk/t单位(hPa)"
          : info.hpa
          ? Number(info.hpa || 0).toFixed(2) + "Dk/t单位(hPa)"
          : null;
      form.setFieldsValue({
        [info.id]: {
          oxygencount_hpa: hpa,
          oxygencount_mmhg: mmhg,
        },
      });
      setOxygenPermeabilityModalVisabel(false);
    } catch (err) {
      console.log(err);
    }
  };

  const oxygenPermeabilityCoefficientModalOk = (info) => {
    console.log(info);
    let mmhg =
      info.mmhg === 0
        ? "0.00Dk单位(mmHg)"
        : info.mmhg
        ? Number(info.mmhg || 0).toFixed(2) + "Dk单位(mmHg)"
        : null;
    let hpa =
      info.hpa === 0
        ? "0.00Dk单位(hPa)"
        : info.hpa
        ? Number(info.hpa || 0).toFixed(2) + "Dk单位(hPa)"
        : null;
    form.setFieldsValue({
      [info.id]: {
        oxygen_mmhg: mmhg,
        contactoxygen: hpa,
      },
    });
    setOxygenPermeabilityCoefficientModalVisabel(false);
  };

  const openOxygenModal = (info, id) => {
    let englishName = info.english_name;
    if (["contactoxygen", "oxygen_mmhg"].includes(englishName)) {
      // 打开透氧系数弹窗
      setOxygenPermeabilityModalID(id);
      setOxygenMmhg(
        get(
          (get(form.getFieldValue(id), "oxygen_mmhg") || "").split("Dk单位"),
          "[0]"
        ) || null
      );
      setContactOxygen(
        get(
          (get(form.getFieldValue(id), "contactoxygen") || "").split("Dk单位"),
          "[0]"
        ) || null
      );
      setOxygenPermeabilityCoefficientModalVisabel(true);
    } else if (["oxygencount_hpa", "oxygencount_mmhg"].includes(englishName)) {
      // 打开透氧量弹窗
      setOxygenPermeabilityModalID(id);
      setOxygenCountMmhg(
        get(
          (get(form.getFieldValue(id), "oxygencount_mmhg") || "").split("Dk/t"),
          "[0]"
        ) || null
      );
      setOxygenCountHPa(
        get(
          (get(form.getFieldValue(id), "oxygencount_hpa") || "").split("Dk/t"),
          "[0]"
        ) || null
      );
      setOxygenPermeabilityModalVisabel(true);
    }
  };
  const restrictTwoNumber = (inputValue, record) => {
    if (!inputValue) {
      return false; // 空输入返回 true
    } else {
      const numPattern = /[\d.]+/; // 匹配数字和小数点
      const numberMatch = inputValue.match(numPattern);
      if (numberMatch) {
        const number = numberMatch[0];
        if (
          [
            "coloreddiameter",
            "contactarc",
            "contactdiameter",
            "oxygen_mmhg",
            "contactoxygen",
            "oxygencount_hpa",
            "oxygencount_mmhg",
          ].includes(record.property_key)
        ) {
          return !(
            Number.isInteger(number) || number.split(".")[1].length === 2
          ); // 不符合则返回 true
        } else if (
          ["contactthickness", "contactrefraction"].includes(
            record.property_key
          )
        ) {
          return !(
            Number.isInteger(number) || number.split(".")[1].length === 3
          ); // 不符合则返回 true
        }
      } else {
        return false;
      }
    }
  };
  const validateUsername = (key, value) => {
    const property_key = key.field.split(".")[1];
    if (
      [
        "coloreddiameter",
        "contactarc",
        "contactdiameter",
        "oxygen_mmhg",
        "contactoxygen",
        "oxygencount_hpa",
        "oxygencount_mmhg",
      ].includes(property_key) &&
      restrictTwoNumber(value, {
        property_key: property_key,
      })
    ) {
      return Promise.reject(new Error("数字部分请保留2位小数"));
    } else if (
      ["contactthickness", "contactrefraction"].includes(property_key) &&
      restrictTwoNumber(value, {
        property_key: property_key,
      })
    ) {
      return Promise.reject(new Error("数字部分请保留3位小数"));
    }
    return Promise.resolve();
  };
  return (
    <div className={styles.extend_form}>
      <AddColor
        initData={initData}
        info={info}
        changeInfo={setInfo}
        saveSession={saveSession}
      />
      {info.length > 0 && (
        <div>
          <div className={styles.extend_spec}>扩展属性</div>
          <div className={styles.extend_title}>
            <div className={styles.extend_property}>属性名称</div>
            <div className={styles.operate}>操作</div>
          </div>
          <div className={styles.list}>
            {/* 标题行 */}
            <div className={styles.design}>
              {initData.map((item) => (
                <div className={styles.design_item} key={item.english_name}>
                  <span style={{ color: "red" }}>
                    {item.is_required && "*"}
                  </span>
                  {item.property_name}
                </div>
              ))}
            </div>
            <Form
              form={form}
              className={
                info.length < 5 ? styles.title_main : styles.title_main_scroll
              }
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onChange={saveSession}
            >
              {info.map((item, index) => (
                <div key={item} style={{ textAlign: "center" }}>
                  <Form.List name={item}>
                    {() => (
                      <div>
                        <div style={{ marginBottom: "20px" }}>
                          {item ? item : "--"}
                          {index === 0 && (
                            <Tooltip title="复制">
                              <CopyTwoTone
                                style={{
                                  fontSize: "18px",
                                  marginLeft: "5px",
                                }}
                                onClick={copyInfo}
                              />
                            </Tooltip>
                          )}
                        </div>
                        {initData.map((ele) => (
                          <div
                            className={styles.items_content}
                            key={ele.english_name}
                          >
                            {ele.edit_method == "text" && (
                              <Form.Item
                                name={[ele.english_name]}
                                rules={[
                                  {
                                    required: ele.is_required,
                                    message: `请输入${ele.property_name}`,
                                  },
                                  { validator: validateUsername },
                                ]}
                                className={styles.main_item}
                              >
                                <Input
                                  onClick={() => {
                                    openOxygenModal(ele, item);
                                  }}
                                  readOnly={[
                                    "oxygen_mmhg",
                                    "contactoxygen",
                                    "oxygencount_mmhg",
                                    "oxygencount_hpa",
                                  ].includes(ele.english_name)}
                                  style={{ width: "200px", display: "block" }}
                                />
                              </Form.Item>
                            )}
                            {(ele.edit_method == "single" ||
                              ele.edit_method == "multiple") && (
                              <Form.Item
                                name={[ele.english_name]}
                                rules={[
                                  {
                                    required: ele.is_required,
                                    message: `请输入${ele.property_name}`,
                                  },
                                ]}
                                className={styles.main_item}
                              >
                                <Select
                                  style={{ width: "120px", display: "block" }}
                                  allowClear
                                  fieldNames={{
                                    label: "dict_name",
                                    value: "dict_key",
                                  }}
                                  options={ele.value_list}
                                  mode={
                                    ele.edit_method === "multiple" && "multiple"
                                  }
                                />
                              </Form.Item>
                            )}
                            {index === 0 && (
                              <Tooltip title="当前值复制给整行">
                                <CopyTwoTone
                                  style={{
                                    marginTop: "-10px",
                                    fontSize: "18px",
                                  }}
                                  onClick={() => copyLineInfo(ele.english_name)}
                                />
                              </Tooltip>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Form.List>
                </div>
              ))}
            </Form>
            <div className={styles.operate} style={{ color: "#189eff" }}>
              {initData.map((item) => (
                <div
                  key={item.english_name}
                  className={styles.design_item}
                  onClick={() => {
                    setIsModalOpen(true);
                    setModalData(item);
                  }}
                >
                  批量设置
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <Modal
        title={modalData ? modalData.property_name : ""}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
        width={600}
      >
        <div className={styles.modal_title}>
          <div className={styles.title_text}>花色</div>
          <div className={styles.title_text}>
            {modalData ? modalData.property_name : ""}
          </div>
        </div>
        <Form
          name="modalForm"
          form={modalForm}
          layout="inline"
          autoComplete="off"
        >
          {modalCount.map((item, index) => (
            <Form.List name={item} key={item}>
              {() => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                  }}
                >
                  <Form.Item
                    name="color"
                    rules={[{ required: true, message: `请选择花色!` }]}
                    style={{ marginBottom: "20px" }}
                  >
                    <Select
                      placeholder="请选择"
                      style={{ width: "180px" }}
                      allowClear
                      options={
                        info.length > 0 &&
                        info.map((item, index) => {
                          return {
                            label: item,
                            value: index,
                          };
                        })
                      }
                      mode="multiple"
                    />
                  </Form.Item>
                  {modalData.edit_method == "text" && (
                    <Form.Item
                      name={[modalData.english_name]}
                      rules={[
                        {
                          required: modalData.is_required,
                          message: `请输入${modalData.property_name}`,
                        },
                      ]}
                      className={styles.main_item}
                    >
                      <Input
                        placeholder="请输入"
                        style={{ width: "180px", display: "block" }}
                      />
                    </Form.Item>
                  )}
                  {(modalData.edit_method == "single" ||
                    item.edit_method == "multiple") && (
                    <Form.Item
                      name={[modalData.english_name]}
                      rules={[
                        {
                          required: modalData.is_required,
                          message: `请输入${modalData.property_name}`,
                        },
                      ]}
                      className={styles.main_item}
                    >
                      <Select
                        placeholder="请选择"
                        style={{ width: "180px", display: "block" }}
                        allowClear
                        fieldNames={{
                          label: "dict_name",
                          value: "dict_key",
                        }}
                        options={modalData.value_list}
                        mode={item.edit_method === "multiple" && "multiple"}
                      />
                    </Form.Item>
                  )}
                  <div
                    onClick={() => {
                      setModalCount(() =>
                        modalCount.filter((ele) => ele !== item)
                      );
                    }}
                    style={{
                      color: "#1890ff",
                      cursor: "pointer",
                      paddingTop: "5px",
                    }}
                  >
                    删除
                  </div>
                </div>
              )}
            </Form.List>
          ))}
        </Form>
        <span
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={() =>
            setModalCount((pre) => [...pre, pre[pre.length - 1] + 1])
          }
        >
          添加
        </span>
      </Modal>

      {
        // 修改透氧量弹窗
        oxygenPermeabilityModalVisabel && (
          <OxygenPermeabilityModal
            id={oxygenPermeabilityModalID}
            onCancel={() => {
              setOxygenPermeabilityModalVisabel(false);
            }}
            oxygenCountHPa={oxygenCountHPa}
            oxygenCountMmhg={oxygenCountMmhg}
            open={oxygenPermeabilityModalVisabel}
            onOk={oxygenPermeabilityModalOk}
          />
        )
      }
      {
        // 修改透氧系数弹窗
        oxygenPermeabilityCoefficientModalVisabel && (
          <OxygenPermeabilityCoefficient
            onCancel={() => {
              setOxygenPermeabilityCoefficientModalVisabel(false);
            }}
            contactOxygen={contactOxygen}
            oxygenMmhg={oxygenMmhg}
            id={oxygenPermeabilityModalID}
            open={oxygenPermeabilityCoefficientModalVisabel}
            onOk={oxygenPermeabilityCoefficientModalOk}
          />
        )
      }
    </div>
  );
});

export default ExtendForm;
//添加花色
const AddColor = (props) => {
  const { info, changeInfo, saveSession } = props;
  const [value, setValue] = useState("");
  //新增
  const handleAdd = () => {
    //判空
    if (!value) {
      message.warn("请填写花色");
      return;
    }
    //判重复
    if (info.includes(value)) {
      message.warn("不能重复添加花色");
      return;
    }
    setValue("");
    changeInfo((pre) => [...pre, value]);
    saveSession();
  };
  //删除
  const handleDeColor = (value) => {
    changeInfo(() => info.filter((item) => value !== item));
    saveSession();
  };
  return (
    <div>
      <div>
        <span
          style={{
            display: "inline-block",
            width: "100px",
            textAlign: "right",
          }}
        >
          <span style={{ color: "red" }}>*</span>花色：
        </span>
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={{ width: "244px" }}
          placeholder="请输入"
        />
        <span
          style={{ color: "#1890ff", margin: "0 20px", cursor: "pointer" }}
          onClick={handleAdd}
        >
          添加
        </span>
      </div>
      <div style={{ marginLeft: "96px" }}>
        {info.length > 0 &&
          info.map((item, index) => (
            <div key={item} className={styles.title_color}>
              <Popconfirm
                title="确认删除?"
                onConfirm={() => handleDeColor(item)}
                okText="确认"
                cancelText="取消"
                trigger="hover"
              >
                {item}
              </Popconfirm>
            </div>
          ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/components/ExtendForm.jsx